import React from 'react';
import { StyledHeader } from './Header.styles';

interface Props {
  sticky?: boolean;
  children?: React.ReactNode;
  className?: string;
  dataQaId: string;
}

const Header = ({ sticky, children, className, dataQaId }: Props) => {
  return (
    <StyledHeader
      sticky={sticky}
      style={{ position: sticky ? 'sticky' : 'static' }}
      className={className}
      data-qa-id={dataQaId}
    >
      {children}
    </StyledHeader>
  );
};

export default Header;
